import ContentTranslation from './js/ContentTranslation';

export default ContentTranslation;
